import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { useDashboard } from '@/hooks/useApi';
import { useTranslation } from 'react-i18next';
import { ChartBarIcon } from '@heroicons/react/24/outline';

export default function RevenueChart() {
  const { t } = useTranslation();
  const { data, isLoading } = useDashboard();

  if (isLoading) {
    return <div className="h-64 rounded-lg bg-gray-50 animate-pulse" />;
  }

  const chartData = (data?.revenueByMonth || []).map((m) => ({
    month: m.month,
    revenue: parseFloat(m.revenue || '0'),
  }));

  const hasData = chartData.some((d) => d.revenue > 0);

  if (!hasData) {
    return (
      <div className="h-64 flex flex-col items-center justify-center text-center">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-indigo-50 mb-3">
          <ChartBarIcon className="h-6 w-6 text-indigo-500" />
        </div>
        <p className="text-sm font-medium text-gray-900">{t('dashboard.emptyRevenue')}</p>
        <p className="text-xs text-gray-500 mt-1">{t('dashboard.emptyRevenueHint')}</p>
      </div>
    );
  }

  return (
    <div className="h-64">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData} margin={{ top: 4, right: 4, bottom: 0, left: -12 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" vertical={false} />
          <XAxis
            dataKey="month"
            tick={{ fill: '#6b7280', fontSize: 12 }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fill: '#6b7280', fontSize: 12 }}
            axisLine={false}
            tickLine={false}
            tickFormatter={(v: number) => `€${(v / 1000).toFixed(0)}k`}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: '#ffffff',
              border: '1px solid #e5e7eb',
              borderRadius: 8,
              color: '#111827',
              fontSize: 13,
              boxShadow: '0 4px 6px -1px rgba(0,0,0,0.07)',
            }}
            cursor={{ fill: 'rgba(99,102,241,0.06)' }}
            formatter={(value: number) => [`€${value.toLocaleString()}`, 'Revenue']}
          />
          <Bar
            dataKey="revenue"
            fill="#4f46e5"
            radius={[4, 4, 0, 0]}
            maxBarSize={40}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
